import { AlertTriangle } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

interface RiskAlert {
  id: string;
  category: string;
  subject: string;
  detail: string;
  severity: 'high' | 'medium';
}

interface RiskAlertsTableProps {
  data: RiskAlert[];
}

export function RiskAlertsTable({ data }: RiskAlertsTableProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Needs Attention</CardTitle>
        <CardDescription>
          Bottlenecks and follow-ups that need hiring attention
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Category</TableHead>
              <TableHead>Subject</TableHead>
              <TableHead>Detail</TableHead>
              <TableHead className="text-right">Severity</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} className="text-center text-muted-foreground">
                  No risk alerts right now
                </TableCell>
              </TableRow>
            ) : (
              data.map((alert) => (
                <TableRow key={alert.id}>
                  <TableCell>
                    <div className="flex items-center gap-2 font-medium">
                      <AlertTriangle className="h-4 w-4 text-amber-500" />
                      {alert.category}
                    </div>
                  </TableCell>
                  <TableCell>{alert.subject}</TableCell>
                  <TableCell className="text-muted-foreground">{alert.detail}</TableCell>
                  <TableCell className="text-right">
                    <Badge variant={alert.severity === 'high' ? 'destructive' : 'outline'}>
                      {alert.severity}
                    </Badge>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
